<template>
  <div id="superadmin-shell">
    <nav class="navbar navbar-vertical fixed-left border-right navbar-expand-md bg-white navbar-light super-sidenav"
      id="sidenav-main">
      <div class="container-fluid">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#superadmin-collapse"
          aria-controls="superadmin-collapse" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>

        <router-link :to="{ name: 'dashboard' }" class="super-brand">
          <img src="@/assets/img/brand/logo-round-sm.png" class="navbar-brand-img" alt="Snap & Bill">
          <span>SuperAdmin</span>
        </router-link>

        <div class="collapse navbar-collapse" id="superadmin-collapse">
          <div class="superadmin-intro">
            <p class="superadmin-kicker">Control Center</p>
            <h6 class="mb-1">Manage providers, sites, and rates.</h6>
            <p class="mb-0 text-muted">A focused workspace for system configuration.</p>
          </div>

          <ul class="navbar-nav superadmin-nav">
            <li class="nav-section">Overview</li>
            <li class="nav-item">
              <router-link :to="{ name: 'dashboard' }" class="nav-link">
                <i class="fas fa-tachometer-alt"></i>
                <span>Dashboard</span>
              </router-link>
            </li>

            <li class="nav-section">Configuration</li>
            <li class="nav-item">
              <router-link :to="{ name: 'serviceProvider' }" class="nav-link">
                <i class="fas fa-building"></i>
                <span>Service Providers</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'siteManagement' }" class="nav-link">
                <i class="fas fa-city"></i>
                <span>Site Management</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'rateManagement' }" class="nav-link">
                <i class="fas fa-file-invoice-dollar"></i>
                <span>Rate Management</span>
              </router-link>
            </li>

            <li class="nav-section">System</li>
            <li class="nav-item">
              <router-link :to="{ name: 'laravelLogs' }" class="nav-link">
                <i class="fas fa-terminal"></i>
                <span>Laravel Logs</span>
              </router-link>
            </li>
          </ul>

          <div class="superadmin-footer">
            <div class="superadmin-version">Version {{ versionLabel }}</div>
            <button type="button" class="btn btn-outline-danger btn-block" @click="logout">
              <i class="fas fa-sign-out-alt mr-2"></i>
              Logout
            </button>
          </div>
        </div>
      </div>
    </nav>

    <div class="main-content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { appVersion } from '@/config'

export default {
  name: 'superAdmin',
  computed: {
    versionLabel() {
      return `v${appVersion}`
    }
  },
  methods: {
    logout() {
      localStorage.clear()
      this.$router.replace({ name: 'adminLogin' })
    }
  }
}
</script>

<style>
#superadmin-shell .super-sidenav {
  background: linear-gradient(180deg, #ffffff 0%, #f6f8fc 100%);
}

#superadmin-shell .super-brand {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  margin: 0 auto 1rem;
  color: #2b3553;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  text-decoration: none;
}

#superadmin-shell .super-brand span {
  font-size: 0.85rem;
}

#superadmin-shell .superadmin-intro {
  margin: 1rem 0 1.5rem;
  padding: 1rem;
  border-radius: 1rem;
  background: #f7f9fc;
  border: 1px solid #e8edf7;
}

#superadmin-shell .superadmin-kicker {
  margin-bottom: 0.35rem;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #5e72e4;
}

#superadmin-shell .superadmin-nav .nav-section {
  margin: 1rem 0 0.5rem;
  padding: 0 1rem;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #8898aa;
}

#superadmin-shell .superadmin-nav .nav-link {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  margin: 0.2rem 0;
  padding: 0.85rem 1rem;
  border-radius: 0.85rem;
  color: #344767;
  font-weight: 600;
  transition: all 0.2s ease;
}

#superadmin-shell .superadmin-nav .nav-link i {
  width: 1rem;
  text-align: center;
  color: #5e72e4;
}

#superadmin-shell .superadmin-nav .nav-link:hover {
  background: #eef2ff;
  color: #1f2a44;
}

#superadmin-shell .superadmin-nav .router-link-exact-active,
#superadmin-shell .superadmin-nav .router-link-active {
  background: linear-gradient(135deg, #5e72e4 0%, #3d55df 100%);
  color: #fff;
  box-shadow: 0 10px 24px rgba(94, 114, 228, 0.22);
}

#superadmin-shell .superadmin-nav .router-link-exact-active i,
#superadmin-shell .superadmin-nav .router-link-active i {
  color: #fff;
}

#superadmin-shell .superadmin-footer {
  margin-top: auto;
  padding-top: 1rem;
}

#superadmin-shell .superadmin-version {
  margin-bottom: 0.75rem;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #94a3b8;
}

@media (max-width: 767.98px) {
  #superadmin-shell .superadmin-intro {
    margin-top: 0.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/layouts/superAdmin.vue